import { render, staticRenderFns } from "./VideoCard.component.vue?vue&type=template&id=5862210c&scoped=true&"
import script from "./VideoCard.component.vue?vue&type=script&lang=js&"
export * from "./VideoCard.component.vue?vue&type=script&lang=js&"
import style0 from "./VideoCard.component.vue?vue&type=style&index=0&id=5862210c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862210c",
  null
  
)

export default component.exports